Ext.define('SA.AcsTable.TableSearchPopupSizeGauge', {
    alias: 'widget.acs-table-search-popup-size-gauge',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-acs-table-search-popup-size-gauge',

    items: [
        {
            xtype: 'acs-table-search-popup-content'
        }
    ],

    resolveSizing() {
        var bodySize = this.getBodySize(),
            fieldBBox = this.getFieldBBox(),
            maxWidth = bodySize.width - fieldBBox.left - this.popupMargin.right,
            intrinsicSize, scrollbarSize, maxHeight, needsScrollbar, constrainedSize, buttonWidth;

        this.el.setStyle('maxWidth', `${maxWidth}px`);

        intrinsicSize = this.getSize();
        scrollbarSize = this.getScrollbarSize();
        maxHeight = bodySize.height - fieldBBox.bottom - this.popupArrowHeight - this.popupMargin.bottom;
        needsScrollbar = intrinsicSize.height > maxHeight;

        constrainedSize = SA.view.ConstrainedSizeResolver.getConstrainedSize({
            containerSize: {width: maxWidth, height: maxHeight},
            contentSize: intrinsicSize,
            contentWidthPlusScrollbarWidth: intrinsicSize.width + scrollbarSize.width,
            contentHeightPlusScrollbarHeight: intrinsicSize.height + scrollbarSize.height
        });

        buttonWidth = constrainedSize.width - (needsScrollbar ? scrollbarSize.width : 0);

        return {popupSize: constrainedSize, buttonWidth};
    },

    setData(datq) {
        this.contentCmp.setData(datq);
    }
});